
<nav mat-tab-nav-bar [tabPanel]="tabPanel">
    <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>   
    <!-- <a mat-tab-link class="d-none d-md-inline-flex" *ngFor="let e of mainLinks" [routerLink]="e.link" routerLinkActive [disabled]="!e.enabled"
      #rla="routerLinkActive" [active]="rla.isActive">
      <cqes-icon [icon]="e.icon"></cqes-icon>
      {{e.label | translate}}
    </a> -->
    <a mat-tab-link class="d-none d-md-inline-flex"
   *ngFor="let e of mainLinks"
   [routerLink]="e.enabled ? e.link : null"
   routerLinkActive
   #rla="routerLinkActive"
   [active]="rla.isActive"
   [class.disabled-link]="!e.enabled"
   [attr.aria-disabled]="!e.enabled">
   <cqes-icon [icon]="e.icon"></cqes-icon>
   {{e.label | translate}}
</a>
    <span class="nav-responsive d-md-none" *ngFor="let e of mainLinks" [routerLink]="e.link" routerLinkActive
      #rla="routerLinkActive" [matMenuTriggerFor]="clientMenu">
      <a *ngIf="rla.isActive" mat-tab-link [disabled]="!e.enabled">
        <cqes-icon icon="menu"></cqes-icon>{{e.label | translate}}
      </a>
    </span>
  </nav>

  <mat-menu #clientMenu="matMenu" [overlapTrigger]="false" class="nav-responsive-overlay">
    <button mat-menu-item *ngFor="let e of mainLinks" [routerLink]="e.link" routerLinkActive="active">
      <cqes-icon [icon]="e.icon"></cqes-icon>
      {{e.label | translate}}
    </button>
  </mat-menu>


  <div class="router-contents">
    <div [@routeAnimations]="prepareOutlet(o)"> 
      <div class="container">
        <div class="row">
          <div class="col-12">
            <router-outlet #o="outlet"></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </div>